import React from "react";

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, info: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, info) {
		this.setState({ info });
		// eslint-disable-next-line no-console
		console.error("ErrorBoundary capturou:", error, info);
	}

	render() {
		if (this.state.hasError) {
			const err = this.state.error;
			const info = this.state.info;
			return (
				<div
					style={{
						minHeight: "100vh",
						background: "#0f172a",
						color: "#f8fafc",
						padding: 32,
						fontFamily: "system-ui, sans-serif",
						overflow: "auto",
					}}
				>
					<div
						style={{
							maxWidth: 960,
							margin: "0 auto",
							background: "#1e293b",
							border: "1px solid #334155",
							borderRadius: 12,
							padding: 24,
						}}
					>
						<h1 style={{ fontSize: 20, color: "#f97316", margin: 0, marginBottom: 8 }}>
							⛔️ Erro de runtime — não é tela branca mais
						</h1>
						<p style={{ opacity: 0.8, margin: 0, marginBottom: 16 }}>
							Aconteceu um erro ao carregar a página. Copie as informações
							abaixo e envie para o suporte técnico.
						</p>
						<div
							style={{
								background: "#0b1220",
								border: "1px solid #334155",
								borderRadius: 8,
								padding: 16,
								overflow: "auto",
								marginBottom: 16,
							}}
						>
							<div style={{ color: "#94a3b8", fontSize: 12, marginBottom: 4 }}>
								Mensagem
							</div>
							<pre
								style={{
									margin: 0,
									color: "#fca5a5",
									whiteSpace: "pre-wrap",
									wordBreak: "break-word",
									fontFamily: "ui-monospace, monospace",
									fontSize: 13,
								}}
							>
								{err ? String(err.message || err) : "(sem mensagem)"}
							</pre>
						</div>
						{err && err.stack ? (
							<div
								style={{
									background: "#0b1220",
									border: "1px solid #334155",
									borderRadius: 8,
									padding: 16,
									overflow: "auto",
									marginBottom: 16,
								}}
							>
								<div style={{ color: "#94a3b8", fontSize: 12, marginBottom: 4 }}>
									Stack
								</div>
								<pre
									style={{
										margin: 0,
										color: "#cbd5e1",
										whiteSpace: "pre-wrap",
										wordBreak: "break-word",
										fontFamily: "ui-monospace, monospace",
										fontSize: 12,
										maxHeight: 320,
										overflow: "auto",
									}}
								>
									{String(err.stack)}
								</pre>
							</div>
						) : null}
						{info && info.componentStack ? (
							<div
								style={{
									background: "#0b1220",
									border: "1px solid #334155",
									borderRadius: 8,
									padding: 16,
									overflow: "auto",
									marginBottom: 16,
								}}
							>
								<div style={{ color: "#94a3b8", fontSize: 12, marginBottom: 4 }}>
									Árvore de componentes
								</div>
								<pre
									style={{
										margin: 0,
										color: "#93c5fd",
										whiteSpace: "pre-wrap",
										wordBreak: "break-word",
										fontFamily: "ui-monospace, monospace",
										fontSize: 12,
										maxHeight: 240,
										overflow: "auto",
									}}
								>
									{String(info.componentStack)}
								</pre>
							</div>
						) : null}
						<div style={{ display: "flex", gap: 12 }}>
							<button
								onClick={() => window.location.reload()}
								style={{
									background: "#f97316",
									color: "white",
									border: "none",
									padding: "10px 16px",
									borderRadius: 8,
									fontWeight: 600,
									cursor: "pointer",
								}}
							>
								🔄 Recarregar página
							</button>
							<button
								onClick={() => this.setState({ hasError: false, error: null, info: null })}
								style={{
									background: "#334155",
									color: "white",
									border: "none",
									padding: "10px 16px",
									borderRadius: 8,
									fontWeight: 600,
									cursor: "pointer",
								}}
							>
								Tentar continuar
							</button>
						</div>
					</div>
				</div>
			);
		}
		return this.props.children;
	}
}
